import { DSNCMorePosts } from 'shared-definitions/types'
import { ApiComponentMorePosts } from 'data-source/types.wp'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { pLinkMapper, PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'

export function ncMorePosts(input: ApiComponentMorePosts, opts: PLinkMapperOpts): DSNCMorePosts {
  return {
    resource: 'nc-more-posts',
    title: input.main_title,
    highlight: input.title,
    items: input.posts.flatMap(item => {
      const image = imageMapper(item.image, opts)
      if (!image) {
        return []
      }
      return {
        title: item.title,
        pLink: pLinkMapper(item.slug, opts),
        image,
      }
    }),
  }
}
